module.exports = __webpack_public_path__ + "static/media/jf-logo-no-clip.29df8c5b.png";